import React from "react";
import { Input } from "../../Input";

export default class Bin extends React.Component{
    constructor(props){
        super(props);
        this.state={
            binInput: ""
        }
    }
    handleInput=(e)=>{
        const target = e.target;
        const value = target.value;
        const name = target.name;
        if(this.state.binInput==="0" && (this.state.binInput==value[1])){
            this.setState({binInput: this.state.binInput})
            return;
        }
        let nv = "";
        nv = this.props.caracterFilter(value,name);
        this.setState({binInput: nv})
    }
    componentDidUpdate(prevProps,prevState){
        if(prevState.binInput!==this.state.binInput){
            this.props.setFrom("bintodec",this.props.binToDec(this.state.binInput));
            this.props.setFrom("bintohex",this.props.binToHex(this.state.binInput))
        }
    }
    componentWillReceiveProps(nextProps){
        if(nextProps.touched.hexInput){
            // if(nextProps.hextobin===""){
            //     this.setState({binInput: ""})
            //     return
            // }
            this.setState({binInput: nextProps.hextobin})
        }
        if(nextProps.touched.decInput){
            // if(nextProps.dectobin===""){
            //     this.setState({binInput: ""})
            //     return
            // }
            this.setState({binInput: nextProps.dectobin})
        } 
    }
   

    render(){
    return(
            <Input
                textColor="red"  
                className="form-control"
                name="binInput" 
                type="text" 
                value={this.state.binInput} 
                onChange={this.handleInput} 
                onBlur={this.props.onBlur("binInput")} 
                onFocus={this.props.onFocus("binInput")}
            />
    );
    }
    
}